import React from 'react'
import {Button, Typography} from "antd";
import routesConfig from "routesConfig";
import {useHistory} from "react-router";

const {Paragraph } = Typography;

export default function CameraAccessView(props) {
    const history = useHistory()
    return <div className='selection-methods'>
        <Paragraph style={{color: 'white', paddingBottom: '15px', marginTop: '9rem'}}> رورو از دوربین گوشی شما استفاده
            خواهد کرد تا کد QR بر روی اسکوتر را خوانده و اسکوتر را برای شما باز کند</Paragraph>
        <div className='clearfix'>
            <div className='vehicle-selection-methods'>
                <Button type="primary" htmlType="submit" block={true} style={{borderRadius: "5px"}} size='large'
                        onClick={event => history.replace(routesConfig.qrcodeScanning)}>
                    اجازه دسترسی به دوربین
                </Button>
            </div>
        </div>
    </div>;
}
